import React, {useEffect, useState} from "react"
import { Container, Draggable } from "react-smooth-dnd"
import Paper from '@material-ui/core/Paper'
import Card from '@material-ui/core/Card'
import Button from '@material-ui/core/Button'
import ButtonGroup  from '@material-ui/core/ButtonGroup'
import GetAppIcon from '@material-ui/icons/GetApp'
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import IconButton from "@material-ui/core/IconButton"
import ListItemText from "@material-ui/core/ListItemText"
import { useSelectedSOPs, setSelectedSOPs, usePlan } from '../redux/plan'
import { convertPlanToDocx, getSopType } from '../modules/db'
import Search from '@material-ui/icons/Search'
import DeleteIcon from '@material-ui/icons/Delete'
import SpellcheckRounded from '@material-ui/icons/SpellcheckRounded'
import { getFinal, getSingle } from '../modules/db'
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { setOpenDialog, useRedirectToPreview, setRedirectToPreview, setSelectedModule } from '../redux/navigation'
import { useToken } from "../redux/auth";
import { editorType } from "./creator"
import { makeStyles, } from '@material-ui/core/styles'
import _ from 'lodash'
import Badge from '@material-ui/core/Badge'
import { theme } from "../theme";

const useStyles = makeStyles((theme) => ({
    section: {
      borderBottomColor:'black',
      borderBottomWidth:2,
      borderBottomStyle:'solid',
      marginBottom:10,
      textAlign: 'left',
      fontSize:'large'
    },
}))

const style = {
  grab : {
    cursor: 'grab'
  },
  grabbing : {
  cursor: 'grabbing'
  },
  resize : {
    cursor: 'ns-resize'
  }
 }
 const selected = style.grab

const downloadSopList = async ({sops, hi, hs, ccp}, token) => {
  console.log({sops, hi, hs, ccp});
  setOpenDialog({open:true, title: 'Please wait', txt:'Wait while the file is ready',neg:null,pos:null,noLabel:null,yesLabel:null})
  let content = `
        <table border="1" width="250">
  `
  sops.forEach( sop => {
    content += `<tr><td>${sop.title}</td></tr>`
  })
  hi.forEach( sop => {
    content += `<tr><td>${sop.title}</td></tr>`
  })
  hs.forEach( sop => {
    content += `<tr><td>${sop.title}</td></tr>`
  })
  ccp.forEach( sop => {
    content += `<tr><td>${sop.title}</td></tr>`
  })
  content += `
        </table>
  `
  const data = await convertPlanToDocx(token, {content, planName: `sopList.docx`})
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `sopList.zip`) 
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setOpenDialog({open:false,txt:'',neg:null,pos:null,noLabel:null,yesLabel:null})
} 

const arrayMove = (array, from, to) => {
  const nArray = [...array]
  let element = nArray[from-1]
  nArray.splice(from-1, 1)
  nArray.splice(to-1, 0, element)
  return nArray
}

const Order = () => {
  const { colors } = theme
  const redirect = useRedirectToPreview()
  const plan = usePlan()
  if(!plan._id){
    const localPlan = JSON.parse(localStorage.getItem("plan"))
    
    if(localPlan && localPlan.plan){
      console.log("local._id "+localPlan.plan._id)
      plan._id = localPlan.plan._id
      plan._rev = localPlan.plan._rev
    }
    

}
  const items = useSelectedSOPs()
  const ids = items?items.map(x => x._id):[]
  const token = useToken()
  const classes = useStyles()
  const [sops, setSops] = useState([])
  const [docs, setDocs] = useState([])
  const [ccp, setCcp] = useState([])
  const [hi, setHI] = useState([])
  const [hs, setHS] = useState([])
  
  const style = {
    grab : {
      cursor: 'grab'
    },
    grabbing : {
    cursor: 'grabbing'
    },
    resize : {
      cursor: 'ns-resize'
    }
   }
   let selected = style.grab

  const onDrop = ({ removedIndex, addedIndex, doctype, ...params }) => {
    let nArr
    switch(doctype){
      case editorType.hi:
        nArr = arrayMove(hi,removedIndex, addedIndex)
        setHI( nArr )
        setSelectedSOPs([...nArr, ...hs, ...ccp, ...docs, ...sops])
        break
      case editorType.hs:
        nArr = arrayMove(hs,removedIndex, addedIndex)
        setHS( nArr )
        setSelectedSOPs([...hi, ...nArr, ...ccp, ...docs, ...sops])
        break
      case editorType.ccp:
        nArr = arrayMove(ccp,removedIndex, addedIndex)
        setCcp( nArr )
        setSelectedSOPs([...hi, ...hs, ...nArr, ...docs, ...sops])
        break
      case editorType.sop:
        nArr = arrayMove(sops,removedIndex, addedIndex)
        setSops( nArr )
        setSelectedSOPs([...hi, ...hs, ...ccp, ...docs, ...nArr])
        break
    }
    selected = style.grab
  }
  const removeFromSelected = (theid, name) => {
    setOpenDialog({
      open:true, 
      txt:`Are you sure you want to remove ${name} from the plan?`,
      pos : () => {
        const filtered = items.filter(
            (e) => {
                return e._id !== theid
            }
        )
        setAllSops(filtered)
        localStorage.setItem('localPlan', filtered)
        setOpenDialog({open:false, txt:'',neg:null,pos:null})
      },
      neg : () => {
        setOpenDialog({open:false, txt:'',neg:null,pos:null})
      }
    }) 
  }

  const handleClick = () => {
    selected = style.grabbing
  }

  const renderElement = (x) => {
    return(
      <Draggable key={x._id} style={selected}  >
        <Card style={{ display:'flex', marginBottom:10}} variant="outlined">
          <DragIndicatorIcon />
          <ListItem className="drag-handle" >
            <ListItemText primary={x.title} />
            <IconButton onClick={() => removeFromSelected(x._id, x.title) }>
              <DeleteIcon style={aqua} /> 
            </IconButton>
            <IconButton onClick={() => getSingle(x._id, token)}>
              { x.doctype === editorType.doc || x.doctype === editorType.sop ?
                  <Badge badgeContent={x.doctype} children={<SpellcheckRounded style={aqua} />} color="primary" />
                :
                  <SpellcheckRounded style={aqua} />
              }
            </IconButton>
      
          </ListItem>
        </Card>
      </Draggable>
    )
  }

  const setAllSops = typos => {
    console.log({typos});
    setSops( typos.filter( x => x?.doctype === editorType.sop || x?.doctype === editorType.doc  ) )
    setCcp( typos.filter( x => x?.doctype === editorType.ccp ) )
    setHI( typos.filter( x => x?.doctype === editorType.hi ) )
    setHS( typos.filter( x => x?.doctype === editorType.hs ) )
    setSelectedSOPs(typos)
  }

  useEffect( () => {
    if(redirect){
      setRedirectToPreview(false)
      setSelectedModule("Preview")
    }

    const getSopsType = async () => {
      const typos = await getSopType(token, {sops:items})
      setAllSops(typos)
    }
    getSopsType()
  }, [])
  
  const aqua = { color: colors.primary }
  const grab = { cursor: 'grab' }
  return (
    <Paper elevation={3} style={{paddingTop:100, paddingBottom:50, paddingLeft:'20%', paddingRight:'20%'}} >
      <h1>{plan.name}</h1>
      {items.length>0?
      <List>
          <Container dragHandleSelector=".drag-handle" lockAxis="y" onDrop={ params => onDrop({...params , doctype: editorType.sop })}>
          { sops.length > 0 &&
            <>
              <div className={classes.section}>Standard Operating Procedures & Documents</div>
              {sops.map( x => renderElement(x) )}
            </>
          }
          </Container>
          { hi.length > 0 &&
            <Container dragHandleSelector=".drag-handle" lockAxis="y" onDrop={ params => onDrop({...params , doctype: editorType.hi })}>
              <div className={classes.section}>Hazard Analysis inputs</div>
              {hi.map( x => renderElement(x) )}
            </Container>
          }
          { hs.length > 0 &&
            <Container dragHandleSelector=".drag-handle" lockAxis="y" onDrop={ params => onDrop({...params , doctype: editorType.hs })}>
              <div className={classes.section}>Hazard Analysis process step</div>
              {hs.map( x => renderElement(x) )}
            </Container>
          }
          { ccp.length > 0 &&
            <Container dragHandleSelector=".drag-handle" lockAxis="y" onDrop={ params => onDrop({...params , doctype: editorType.ccp })}>
              <div className={classes.section}>Critical Control Points</div>
              {ccp.map( x => renderElement(x) )}
            </Container>
          }
      </List>:
      <h1>No SOP is selected</h1>
      }
      <ButtonGroup variant="contained">
        <Button
          variant="contained"
          size="large"
          endIcon={<Search />}
          onClick={() => { getFinal(ids,token)}}
          style={{ 
            backgroundColor: colors.secondary,
            color: colors.light
          }}
        >
          Preview
        </Button>
        <Button
          variant="contained"
          size="large"
          endIcon={<GetAppIcon />}
          onClick={() => { downloadSopList( {sops, hi, hs, ccp}, token)}}
          style={{ 
            backgroundColor: colors.secondary,
            color: colors.light
          }}
        >
          Download SOP List
        </Button>
      </ButtonGroup>
    </Paper>
  )
}
export default Order